import React from 'react';
import { usePlanningActualState } from '../Context/index';

function OptionsTableTotal({ years }) {
  const { checkVisible, getOvarAllFieldTotal, getVSOverallTotal } = usePlanningActualState();
  const options = [
    {
      keyName: 'plannedOption',
      name: 'Planned Options',
      type: 'input',
      display: true,
      Total: 0,
    },
    {
      keyName: 'actualOption',
      name: 'Actual Options',
      type: 'input',
      display: true,
      Total: 0,
    },
  ];

  return (
    <>
      {(years ?? [])?.map((currentYear, yearIndex) => {
        return (
          <table key={yearIndex} className="table custom-table layout-fixed  font-13 mr-3">
            <thead>
              <tr>
                {options.map((salesItem, i) => {
                  const isVisible = checkVisible(salesItem.keyName);
                  return (
                    isVisible && (
                      <th key={i} className="w-200px">
                        <span>
                          {currentYear}&nbsp;
                          {salesItem.name}
                        </span>
                      </th>
                    )
                  );
                })}
              </tr>
            </thead>
            <tbody>
              <tr>
                {options.map((salesItem, i) => {
                  const isVisible = checkVisible(salesItem.keyName);
                  return isVisible && <td key={i}>{getOvarAllFieldTotal(salesItem.keyName, yearIndex, currentYear)}</td>;
                })}
              </tr>
            </tbody>
          </table>
        );
      })}
      <table className="table custom-table layout-fixed font-13 mr-3">
        <thead>
          <tr>
            {(years ?? [])?.map((childYear, i) => {
              return (
                i > 0 && (
                  <th key={i} className="w-200px">
                    <span>
                      {years[0]} vs {childYear} (%)
                    </span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          <tr>
            {(years ?? [])?.map((eleYear, iYear) => {
              return (
                iYear > 0 && (
                  <td key={iYear} className="w-200px">
                    <span>{getVSOverallTotal('plannedOption', 'actualOption', eleYear)}</span>
                  </td>
                )
              );
            })}
          </tr>
        </tbody>
      </table>
    </>
  );
}
export default OptionsTableTotal;
